import LoadingState from "shared/components/state/LoadingState";
import React from 'react';
import { Suspense } from 'react';
import routes from 'app/navigation/routes/routes.config';
import { useRoutes } from 'react-router-dom';
const AppLayout = () => {

    const routing = useRoutes(routes);

    return (
        <Suspense fallback={<LoadingState message="Working on it..." />}>
            {
                routing
            }
        </Suspense>
    );

}

export default AppLayout;